// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck-content .image{\n  display:table\n}[dir] .ck-content .image{\n  clear:both;\n  text-align:center;\n  margin:1em auto\n}\n\n.ck-content .image img{\n  display:block;\n  max-width:100%;\n  min-width:50px\n}\n\n[dir] .ck-content .image img{\n  margin:0 auto\n}", ""]);
// Exports
module.exports = exports;
